<template>
<div class="homeAuctionResult">
    <a class="auctionFont fontLine color333" :href="`https://auction.artron.net/meeting_detail/${titleList.sessionCode}`" target="_blank">{{titleList.name}}</a>
    <div class="info">
        <span class="color999 auctionFont fontLine">成交额：</span><span class="auctionFont color333">{{titleList.money}}</span>
        <span class="color999 auctionFont ml20 fontLine">成交率：</span><span class="auctionFont color333">{{titleList.turnoverRatio}}</span>
    </div>
    <div class="color999 auctionFont font14 mb6">重要拍品：</div>
    <ul class="resultUl">
        <li class="fix" v-for="(item) in list" :key="item.Id">
            <div>
                <a class="title font12" target="_blank">{{item.Title}}</a>
                <span class="price red verdanF12 fr">{{item.CurrencyType}} {{item.CurrencyPrice == 0 ? '--' : item.CurrencyPrice.toLocaleString() }}</span>
            </div>
        </li>
    </ul>
</div>
</template>

<script>
export default {
    name: "homeAuctionResult",
    props:["result","titleList","list"],
    data(){
        return{
            dataObj:{
                seriesName:'中国嘉德2021秋季拍卖会',
                seriesUrl:'https://auction.artron.net/ZGJD-0005/PMH213315/',
                price:'289300万元',
                closeRate:'80.00%',
                goodsList:[
                    {id:1,name:'秋曦图',url:"https://auction.artron.net/paimai-art5193450297/",price:"RMB 195500000",currency:""},
                    {id:2,name:'秋曦图',url:"https://auction.artron.net/paimai-art5193450297/",price:"RMB 195500000",currency:""},
                    {id:3,name:'秋曦图',url:"https://auction.artron.net/paimai-art5193450297/",price:"RMB 195500000",currency:""},
                ],
            }
        }
    }

}
</script>

<style scoped lang="scss">
@import '@/assets/css/auctionCompany.scss';
.homeAuctionResult{

    .info{
        margin: 3px 0 0 0;
    }
    .mb6{
        margin-bottom: 6px;
    }

    .resultUl li{
        margin-bottom: 5px;
        height: 30px;
        line-height: 30px;
        .title{
            color: #333;
            font-family: "微软雅黑";
            display: block;
            float: left;
            line-height: 30px;
            background: url(../../../assets/imgs/old/newliBg.png) no-repeat scroll left center;
            padding-left: 10px;
            display: inline;
            max-width: 180px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .price{
            line-height: 30px;
            display: inline;
        }
    }
}
</style>